import React from 'react';
import { Trophy, Calendar, MapPin, Users, Star } from 'lucide-react';

const WK2026Page = () => {
  return (
    <div>
      <section className="bg-gradient-to-r from-amber-600 to-orange-600 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <Trophy className="w-20 h-20 mx-auto mb-6" />
            <h1 className="text-5xl font-bold mb-6">WK 2026</h1>
            <p className="text-2xl mb-8 opacity-90">
              Het Wereldkampioenschap Voetbal 2026 in Noord-Amerika
            </p>
            <div className="grid grid-cols-3 gap-6">
              <div className="bg-white/20 backdrop-blur-sm p-4 rounded-xl">
                <div className="text-3xl font-bold">11 juni</div>
                <div className="text-sm">Startdatum</div>
              </div>
              <div className="bg-white/20 backdrop-blur-sm p-4 rounded-xl">
                <div className="text-3xl font-bold">19 juli</div>
                <div className="text-sm">Finale</div>
              </div>
              <div className="bg-white/20 backdrop-blur-sm p-4 rounded-xl">
                <div className="text-3xl font-bold">48</div>
                <div className="text-sm">Landen</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-8">Over WK 2026</h2>
          <div className="max-w-4xl">
            <p className="text-lg text-gray-700 mb-6">
              Het Wereldkampioenschap voetbal 2026 wordt het eerste WK dat wordt georganiseerd door drie landen: 
              Canada, Mexico en de Verenigde Staten. Het toernooi vindt plaats van 11 juni tot en met 19 juli 2026.
            </p>
            <p className="text-lg text-gray-700 mb-6">
              Voor het eerst doen er 48 landen mee aan het eindtoernooi, een uitbreiding van 32 naar 48 teams. 
              Dit betekent ook meer wedstrijden: in totaal 104 wedstrijden in plaats van de gebruikelijke 64.
            </p>
            <p className="text-lg text-gray-700">
              Nederland begint zijn WK-campagne op 14 juni tegen Mexico in Los Angeles. Oranje is ingedeeld 
              in poule A samen met Mexico, Ecuador en een nog te bepalen land.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-amber-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-8 text-center">Belangrijke Data</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <div className="bg-white rounded-xl shadow-md p-6">
              <div className="flex items-center mb-4">
                <Calendar className="w-8 h-8 text-amber-600 mr-3" />
                <h3 className="text-xl font-bold">11 juni 2026</h3>
              </div>
              <p className="text-gray-600">Openingwedstrijd in Mexico-Stad. Mexico speelt als eerste gastland.</p>
            </div>
            <div className="bg-white rounded-xl shadow-md p-6">
              <div className="flex items-center mb-4">
                <Calendar className="w-8 h-8 text-amber-600 mr-3" />
                <h3 className="text-xl font-bold">14 juni 2026</h3>
              </div>
              <p className="text-gray-600">Nederland begint tegen Mexico in Los Angeles (22:00 uur NL tijd).</p>
            </div>
            <div className="bg-white rounded-xl shadow-md p-6">
              <div className="flex items-center mb-4">
                <Calendar className="w-8 h-8 text-amber-600 mr-3" />
                <h3 className="text-xl font-bold">19 juli 2026</h3>
              </div>
              <p className="text-gray-600">Finale in het MetLife Stadium, East Rutherford (New York).</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WK2026Page;